module.exports = __webpack_public_path__ + "img/sante_mobile.057b107b.jpg";